export const PREFIX = 'img-crop';

export const INIT_ZOOM = 1;
export const ZOOM_STEP = 0.01;
export const INIT_ROTATE = 0;
export const ROTATE_STEP = 1;
export const MIN_ROTATE = -180;
export const MAX_ROTATE = 180;
